<button mat-icon-button matTooltip="{{ content }}" [matTooltipPosition]="position" tabindex="-1"
        matTooltipClass="{{tooltipClass}}">
    <i class="{{ icon }}"></i>
</button>
